module.exports = __webpack_public_path__ + "static/img/ed.e4eb719.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ed.png
// module id = 5OjJ
// module chunks = 1